// import products from "../data/products";
import ProductCard from "../components/ProductCard";
import { usePdts } from "../context/PdtsContext";

export default function Home(){
    const { aaa, pdts:products, isPdtsLoading } = usePdts() || {};

    return <div
        className="container"
    >
        <h2
            className="mb-4"
        >Our products</h2>
        <div className="row">
            {(products||[]).map(p=><ProductCard
                key={p.id||p.__id}
                product={{...p, price: 100}}
            ></ProductCard>)}

        </div>

    </div>
}